module.exports = (__webpack_require__(23))(7);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react/react.js from dll-reference vendor_1028da341226f1bb1b52
// module id = 3
// module chunks = 0